// extracted by mini-css-extract-plugin
module.exports = {"select":"FormikSelect_select__ZUGPe","select_item":"FormikSelect_select_item__2os0i","error_text":"FormikSelect_error_text__2GW1M"};